import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

import { SaleCheckoutPage } from './sale-checkout.page';
import { AuthGuard } from 'src/app/services/user/auth.guard';

const routes: Routes = [
  {
    path: '',
    component: SaleCheckoutPage,
    canActivate: [AuthGuard],
  },
  {
    path: 'sale-confirmation',
    loadChildren: () => import('./sale-confirmation/sale-confirmation.module').then( m => m.SaleConfirmationPageModule),
    canActivate: [AuthGuard],

  },
  {
    path: 'lineitem-configurator',
    loadChildren: () => import('./lineitem-configurator/lineitem-configurator.module').then( m => m.LineitemConfiguratorPageModule),
    canActivate: [AuthGuard],

  },
  {
    path: 'sale-discount-list',
    loadChildren: () => import('./sale-discount-list/sale-discount-list.module').then( m => m.SaleDiscountListPageModule),
    canActivate: [AuthGuard],

  },
  {
    path: 'sale-more-options-popover',
    loadChildren: () => import('./sale-more-options-popover/sale-more-options-popover.module').then( m => m.SaleMoreOptionsPopoverPageModule),
    canActivate: [AuthGuard],

  },
  {
    path: 'sale-payment-form',
    loadChildren: () => import('./sale-payment-form/sale-payment-form.module').then( m => m.SalePaymentFormPageModule),
    canActivate: [AuthGuard],

  },
  {
    path: 'sale-payment-picker',
    loadChildren: () => import('./sale-payment-picker/sale-payment-picker.module').then( m => m.SalePaymentPickerPageModule),
    canActivate: [AuthGuard],

  },
  {
    path: 'sale-payment',
    loadChildren: () => import('./sale-payment/sale-payment.module').then( m => m.SalePaymentPageModule),
    canActivate: [AuthGuard],

  },
  {
    path: 'sale-product-picker',
    loadChildren: () => import('./sale-product-picker/sale-product-picker.module').then( m => m.SaleProductPickerPageModule),
    canActivate: [AuthGuard],

  },
  {
    path: 'sale-service-picker',
    loadChildren: () => import('./sale-service-picker/sale-service-picker.module').then( m => m.SaleServicePickerPageModule),
    canActivate: [AuthGuard],

  },
  {
    path: 'sale-square-oauth',
    loadChildren: () => import('./sale-square-oauth/sale-square-oauth.module').then( m => m.SaleSquareOauthPageModule),
    canActivate: [AuthGuard],

  },
  {
    path: 'sale-tip-form',
    loadChildren: () => import('./sale-tip-form/sale-tip-form.module').then( m => m.SaleTipFormPageModule),
    canActivate: [AuthGuard],

  },
  {
    path: 'terminal-connection',
    loadChildren: () => import('./terminal-connection/terminal-connection.module').then( m => m.TerminalConnectionPageModule),
    canActivate: [AuthGuard],

  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule],
})
export class SaleCheckoutPageRoutingModule {}
